const isInIframe = () => window?.self !== window?.top;

const isWithinStockwave = () => Array.from(document?.location?.ancestorOrigins || [])
  .some((origin) => {
    try {
      const host = new URL(origin).hostname.toLowerCase();
      return (
        host === 'vauto.com'
        || host.endsWith('.vauto.com')
        || host === 'app.coxautoinc.com'
        || host.endsWith('.app.coxautoinc.com')
      );
    } catch (e) {
      return false;
    }
  });

const iFrameParentDocumentUrl = () => (
  isInIframe()
    ? document?.referrer
    : document?.location?.href);

export {
  isInIframe,
  isWithinStockwave,
  iFrameParentDocumentUrl,
};
